import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useTranslation } from "react-i18next";
import { getErrorMessage } from "@/shared/utils/getErrorMessage";
import { settingsService } from "../services/settings.service";
import type { SettingValue } from "../types";

export function useSettingsList() {
	return useQuery({
		queryKey: ["settings"],
		queryFn: () => settingsService.list(),
	});
}

export interface SettingsGroupSaveInput {
	/** Faqat toast/loading state'ini bitta guruhga bog'lash uchun — PATCH so'roviga ketmaydi. */
	group: string;
	entries: { key: string; value: SettingValue }[];
}

/**
 * Bitta kartadagi (guruhdagi) barcha o'zgargan kalitni ketma-ket
 * `PATCH /settings/{key}` bilan yuboradi (spec §5): bitta muvaffaqiyat/xato
 * toast'i va bitta `invalidateQueries` — har-kalit-o'z-toast'i naqshi
 * ATAYLAB ishlatilmaydi, aks holda N ta o'zgargan kalit N ta toast va N ta
 * refetch keltirardi (eski `SettingsPage`ning har-qator-o'z-tugmasi
 * naqshida shu muammo yo'q edi, chunki har qatorda bitta kalit bor edi;
 * karta boshiga bir nechta kalit chiqqach bu endi muammo bo'lardi).
 *
 * ⚠️ Ketma-ket, PARALLEL emas: birinchi xato qolgan kalitlarni
 * to'xtatadi — spec «xato bo'lsa message.error(), joriy naqsh saqlanadi»
 * deydi, ya'ni murakkab qisman-muvaffaqiyat holati talab qilinmaydi.
 * Muvaffaqiyatsiz chaqiruvdan OLDINGI kalitlar baribir DB'ga yozilgan
 * bo'ladi — sahifa `onSuccess` chaqirilmagani uchun ularni ham qoralamada
 * qoldiradi, keyingi «Saqlash» esa ularni idempotent tarzda qayta yuboradi.
 */
export function useSaveSettingsGroup() {
	const { message } = App.useApp();
	const { t } = useTranslation("settings");
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ entries }: SettingsGroupSaveInput) => {
			for (const { key, value } of entries) {
				await settingsService.update(key, value);
			}
		},
		onSuccess: () => {
			message.success(t("page.saveSuccess"));

			return queryClient.invalidateQueries({ queryKey: ["settings"] });
		},
		onError: (error) => {
			message.error(getErrorMessage(error, t("page.saveError")));
		},
	});
}
